import React, { useState, useEffect } from 'react';
import api from '../../services/api';

export default function Dispatch() {
  const user = JSON.parse(localStorage.getItem('sdx_user') || '{}');
  const [hubs, setHubs] = useState([]);
  const [sortedParcels, setSortedParcels] = useState([]);
  const [selected, setSelected] = useState(new Set());
  const [pendingReceive, setPendingReceive] = useState([]);
  const [form, setForm] = useState({
    origin_hub_id: user.hub_id || 1,
    destination_hub_id: '',
    transport_company: '', bus_reg: '', driver_name: '', driver_phone: '',
    waybill_number: '', waybill_photo_url: 'PENDING_UPLOAD', dispatch_fee_paid: '',
  });
  const [msg, setMsg] = useState('');

  const loadHubs = () => api.get('/hubs').then(r => setHubs(r.data));
  const loadSorted = () => {
    api.get(`/parcels/hub/${form.origin_hub_id}/inbox`).then(r => {
      setSortedParcels(r.data.filter(p => p.status === 'sorted' && (!form.destination_hub_id || p.destination_hub_id === Number(form.destination_hub_id))));
    });
  };
  const loadPending = () => {
    api.get(`/dispatches?destination_hub_id=${form.origin_hub_id}&pending=1`).then(r => setPendingReceive(r.data));
  };

  useEffect(() => { loadHubs(); }, []);
  useEffect(() => { loadSorted(); loadPending(); }, [form.origin_hub_id, form.destination_hub_id]);

  const toggle = (id) => {
    const s = new Set(selected);
    if (s.has(id)) s.delete(id); else s.add(id);
    setSelected(s);
  };

  const submit = async () => {
    setMsg('');
    if (selected.size === 0) return setMsg('Select at least one parcel');
    if (!form.destination_hub_id || !form.transport_company || !form.bus_reg || !form.driver_phone) return setMsg('Fill required fields');
    try {
      const res = await api.post('/dispatches', {
        ...form,
        origin_hub_id: Number(form.origin_hub_id),
        destination_hub_id: Number(form.destination_hub_id),
        dispatch_fee_paid: form.dispatch_fee_paid ? Number(form.dispatch_fee_paid) : null,
        parcel_ids: Array.from(selected),
      });
      setMsg(`Dispatch ${res.data.dispatch_number} created for ${selected.size} parcels`);
      setSelected(new Set());
      loadSorted();
    } catch (e) { setMsg(e.response?.data?.error || 'Error'); }
  };

  const receiveDispatch = async (dispatchId) => {
    try {
      const res = await api.post(`/dispatches/${dispatchId}/receive`);
      setMsg(`Received ${res.data.received} parcels from dispatch #${dispatchId}`);
      loadPending();
    } catch (e) { setMsg(e.response?.data?.error || 'Error'); }
  };

  return (
    <div>
      <h1>Dispatch</h1>

      {pendingReceive.length > 0 && (
        <div className="card" style={{ background: '#fefce8', border: '1px solid #fde047' }}>
          <h2 style={{ color: '#a16207', marginTop: 0 }}>📥 Inbound Dispatches to Receive</h2>
          {pendingReceive.map(d => (
            <div key={d.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: 10, borderBottom: '1px solid #fde047' }}>
              <div>
                <strong>{d.dispatch_number}</strong> · {d.origin_name} → {d.destination_name}<br />
                <span style={{ fontSize: 13, color: '#6b7280' }}>{d.transport_company} · {d.bus_reg} · {d.parcel_count} parcels · dispatched {new Date(d.dispatched_at).toLocaleString()}</span>
              </div>
              <button className="btn btn-primary" onClick={() => receiveDispatch(d.id)}>Receive Batch</button>
            </div>
          ))}
        </div>
      )}

      <div className="card">
        <h2 style={{ marginTop: 0 }}>Create Dispatch</h2>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
          <div>
            <label className="label">Origin Hub</label>
            <select className="input" value={form.origin_hub_id} onChange={e => setForm({ ...form, origin_hub_id: Number(e.target.value) })}>
              {hubs.map(h => <option key={h.id} value={h.id}>{h.name}</option>)}
            </select>
          </div>
          <div>
            <label className="label">Destination Hub *</label>
            <select className="input" value={form.destination_hub_id} onChange={e => setForm({ ...form, destination_hub_id: e.target.value })}>
              <option value="">— select —</option>
              {hubs.filter(h => h.id !== Number(form.origin_hub_id)).map(h => <option key={h.id} value={h.id}>{h.name}</option>)}
            </select>
          </div>
          <div>
            <label className="label">Transport Company *</label>
            <input className="input" value={form.transport_company} onChange={e => setForm({ ...form, transport_company: e.target.value })} placeholder="UBZ / Shalom / Juldan" />
          </div>
          <div>
            <label className="label">Bus Reg *</label>
            <input className="input" value={form.bus_reg} onChange={e => setForm({ ...form, bus_reg: e.target.value })} placeholder="BAM 1234" />
          </div>
          <div>
            <label className="label">Driver Name</label>
            <input className="input" value={form.driver_name} onChange={e => setForm({ ...form, driver_name: e.target.value })} />
          </div>
          <div>
            <label className="label">Driver Phone *</label>
            <input className="input" value={form.driver_phone} onChange={e => setForm({ ...form, driver_phone: e.target.value })} />
          </div>
          <div>
            <label className="label">Waybill / Ticket #</label>
            <input className="input" value={form.waybill_number} onChange={e => setForm({ ...form, waybill_number: e.target.value })} />
          </div>
          <div>
            <label className="label">Dispatch Fee Paid (K)</label>
            <input className="input" type="number" value={form.dispatch_fee_paid} onChange={e => setForm({ ...form, dispatch_fee_paid: e.target.value })} />
          </div>
        </div>
        <p style={{ fontSize: 12, color: '#6b7280', marginBottom: 12 }}>
          ⚠ Waybill photo upload not wired yet — using placeholder <code>PENDING_UPLOAD</code>. Add file upload later.
        </p>

        <h3 style={{ margin: '20px 0 10px' }}>Sorted parcels ready to send ({sortedParcels.length})</h3>
        {sortedParcels.length === 0 ? (
          <p style={{ color: '#6b7280' }}>None sorted yet. Scan-in and mark sorted first.</p>
        ) : (
          <table style={{ width: '100%', fontSize: 13 }}>
            <thead>
              <tr style={{ textAlign: 'left', color: '#6b7280', fontSize: 11, textTransform: 'uppercase' }}>
                <th style={{ padding: '6px 0' }}></th><th>Tracking</th><th>To</th><th>Receiver</th><th>Weight</th>
              </tr>
            </thead>
            <tbody>
              {sortedParcels.map(p => (
                <tr key={p.id} style={{ borderTop: '1px solid #f3f4f6' }}>
                  <td><input type="checkbox" checked={selected.has(p.id)} onChange={() => toggle(p.id)} /></td>
                  <td style={{ fontWeight: 600 }}>{p.tracking_number}</td>
                  <td>{p.destination_hub_name}</td>
                  <td>{p.receiver_name} · {p.receiver_phone}</td>
                  <td>{p.actual_weight_kg ? `${p.actual_weight_kg} kg` : '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

        <div style={{ marginTop: 20, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ color: '#6b7280' }}>{selected.size} selected</span>
          <button className="btn btn-primary" onClick={submit} disabled={selected.size === 0}>Dispatch {selected.size} Parcels</button>
        </div>
        {msg && <p style={{ marginTop: 12, color: msg.includes('Error') ? '#dc2626' : '#16a34a' }}>{msg}</p>}
      </div>
    </div>
  );
}
